import { render } from "./OurBusiness.vue?vue&type=template&id=5ad0a198&scoped=true"
import script from "./OurBusiness.vue?vue&type=script&lang=js"
export * from "./OurBusiness.vue?vue&type=script&lang=js"

import "./OurBusiness.vue?vue&type=style&index=0&id=5ad0a198&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad0a198"]])

export default __exports__